import { FileUploaderButton, Icon } from '@aptuno/aptuno-ui';
import styled from 'styled-components';

export const TitleText = styled.h3`
  margin-left: 16px;
`;

export const IconClose = styled(Icon)`
  color: #9b9b9b;
  margin-right: 16px;
  cursor: pointer;
`;

export const LoadPhotosInfoScreenContent = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 16px;
  padding-top: 24px;
  padding-bottom: 90px;
  gap: 8px;
  ${({ isMobile }) =>
    !isMobile &&
    `
      padding-top: 88px;
      height: calc(100vh - 100px);
    `};
`;

export const HeaderSection = styled.div<{
  bgColor?: string;
  horizontalAlign?: string;
  verticalAlign?: string;
  margin?: string;
  padding?: string;
  isMobile?: boolean;
}>`
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
  height: 100%;
  gap: 8px;
  ${(props) =>
    props.bgColor &&
    `
  background-color: ${props.bgColor};
`};
  ${(props) =>
    props.horizontalAlign &&
    `
  align-items: ${props.horizontalAlign};
`};
  ${(props) =>
    props.margin &&
    `
  margin: ${props.margin};
`};
  ${(props) =>
    props.padding &&
    `
  padding: ${props.padding};
`};
`;

export const InfoListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
`;

export const InfoListItem = styled.div`
  display: flex;
  flex-direction: row;
`;

export const InfoItemIconWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 100%;
  justify-content: center;
  background: #fff9eb;
  margin-right: 22px;
  height: 40px;
  width: 40px;
`;

export const InfoItemIcon = styled(Icon)`
  color: #ffbd11;
  height: 20px;
  width: 20px;
`;

export const InfoListItemTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InfoItemTitle = styled.p<{
  margin?: string;
  align?: string;
}>`
  font-size: ${(props) => props.theme.typography.size.sm3}px;
  line-height: ${(props) => props.theme.typography.lineHeight.sm5}px;
  color: ${(props) => props.theme.colors.textBlack};
  font-weight: 700;
  margin: 0;
  ${(props) => props.align && `text-align: ${props.align}`};
`;

export const TextNormal = styled.p<{ margin?: string; align?: string }>`
  font-size: ${(props) => props.theme.typography.size.sm2}px;
  line-height: ${(props) => props.theme.typography.lineHeight.sm5}px;
  color: ${(props) => props.theme.colors.textGray};
  font-weight: ${(props) => props.theme.typography.weight.regular};
  margin: 0;
  ${(props) => props.align && `text-align: ${props.align}`};
`;

export const LoadPhotoButton = styled(FileUploaderButton)<{ isMobile: boolean }>`
  margin-top: ${({ isMobile }) => (isMobile ? '28px' : '42px')};
  align-self: center;
`;
